import { ExternalLink, Puzzle } from "lucide-react";
import { useT } from "@/i18n";
import { TOOLS, GAME_TEXT } from "@/components/games/content";

export default function GameTools({ tools = TOOLS, hideTitle = false, gridClass = "sm:grid-cols-3" }) {
  const { lang } = useT();
  const tx = GAME_TEXT[lang];
  return (
    <div>
      {!hideTitle && <h3 className="font-fredoka text-xl sm:text-2xl font-bold text-blue-950">{tx.tools}</h3>}
      <div className={`mt-4 grid ${gridClass} gap-4`}>
        {tools.map((t) => (
          <div key={t.id} className={`bg-gradient-to-br ${t.color} rounded-3xl border-4 border-white p-3 shadow-lg flex flex-col`} data-testid={`game-tool-${t.id}`}>
            <div className="flex flex-wrap items-center justify-between gap-2 p-2">
              <div className="flex items-center gap-3 min-w-0">
                <div className="bg-white/90 rounded-2xl p-2.5"><Puzzle className="w-6 h-6 text-blue-950" /></div>
                <p className="font-fredoka text-lg xl:text-xl font-bold text-white bubble-text-sm leading-tight break-words">{t.name}</p>
              </div>
              <span className="bg-white/90 rounded-full px-2.5 py-1 text-xs font-bold text-blue-950 whitespace-nowrap shrink-0">{tx.age} {t.age}</span>
            </div>
            <div className="bg-white/90 rounded-2xl p-3 flex-1 flex flex-col">
              <p className="text-sm font-semibold text-blue-950 flex-1">{t[lang]}</p>
              <a href={t.url} data-age={t.age} target="_blank" rel="noopener noreferrer" className="mt-3 inline-flex items-center gap-1 text-sm font-bold text-blue-700 hover:underline" data-testid={`game-tool-link-${t.id}`}>
                {tx.open} <ExternalLink className="w-4 h-4" />
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
